/* eslint-disable import/no-unused-modules */
import FilterMenusV2 from 'components/FilterMenus/FilterMenusV2';
import {
  SUPPORTED_PM_FILTERS,
  usePmFiltersBuilder
} from 'components/FilterMenus/pm.filters';
import usePmProvider from 'components/hooks/PM/usePmProvider';

const SingleFilterSelector = ({
  filterType,
  selectedFilters,
  onChange,
  customFieldsMapper = null
}) => {
  const pmProvider = usePmProvider();
  const menuItem = SUPPORTED_PM_FILTERS[pmProvider][filterType];
  const currentMenuItem = usePmFiltersBuilder({ [pmProvider]: [filterType] });

  if (!menuItem) return null;

  return (
    <FilterMenusV2
      menuItems={currentMenuItem}
      selectedFilters={selectedFilters}
      buttonTitle={`Select ${menuItem.title}/s`}
      setSelectedFilters={onChange}
      documentIdPrefix={`select-${filterType}`}
      customFieldsMapper={customFieldsMapper}
    />
  );
};

export default SingleFilterSelector;
